module.exports = __webpack_public_path__ + "static/js/1.ac1c1a3d.chunk.worker.js"